// Home images
export const homeImages = {
  hero: '/images/home/hero.jpg',
  logo: '/images/home/logo.jpg'
};

// New Builds images
export const newBuildsImages = Array.from({ length: 4 }, (_, i) => ({
  src: `/images/new-builds/build-${String(i + 1).padStart(2, '0')}.jpg`,
  alt: `New Build Project ${i + 1}`
}));

// Renovations images
export const renovationsImages = Array.from({ length: 11 }, (_, i) => ({
  src: `/images/renovations/reno-${String(i + 1).padStart(2, '0')}.jpg`,
  alt: `Renovation Project ${i + 1}`
}));

// Pools and Landscapes images
export const poolsAndLandscapesImages = Array.from({ length: 6 }, (_, i) => ({
  src: `/images/pool-landscape/pool-${String(i + 1).padStart(2, '0')}.jpg`,
  alt: `Pool & Landscape Project ${i + 1}`
})); 